import React from "react";
import {TextField} from "@material-ui/core";
import ButtonWithLoading from "../../ButtonWithLoading";
import {checkCoupon, retrieveBill} from "../../../../actions/apiCallActions";
import {connect} from "react-redux";
import {changeCoupon} from "../../../../actions/actionCreators";
import i18n from "../../../../i18nextInitiator";
import {compose} from "redux";
import {withRouter} from "react-router-dom";

/**
 * Translation function.
 * @type {TFunction}
 */
const t = i18n.getFixedT('fa','general');
/**
 * maps state to component props.
 * @param state
 */
const mapStateToProps = state => ({ ...state,
    discountCode: state.order.order.discount_code,
    asyncCoupon: state.order.asyncCoupon,
    wrongCoupon: state.order.wrongCoupon,
    couponMessage: state.order.couponMessage
});
const DiscountModal = props => {
    const {
        match: {
            params: {intercity, id}
        }
    } = props;

    const submit = () => {
        checkCoupon()
            .then((res)=> {
                if (res && res.status == 200)
                    props.close()
            }).finally(()=>retrieveBill(id, intercity))
    }

    return <>
        <TextField
            onChange={changeCoupon}
            helperText={props.wrongCoupon && props.couponMessage}
            error={props.wrongCoupon}
            placeholder={t("discount.placeholder")}
            fullWidth
        />
        <ButtonWithLoading
            action={submit}
            loading={props.asyncCoupon}
            disabled={!props.discountCode || props.asyncCoupon}
            size={"large"}
            variant={"contained"}
            color={"primary"}
            text={t("discount.submit")}
            fullWidth/>
        </>
}

export default compose(connect(mapStateToProps), withRouter)(DiscountModal)